import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { PageShell } from "../components/SiteChrome";

export default function Auth() {
  const { user, login, register, googleLogin } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  // already signed in — go straight to the right dashboard
  useEffect(() => {
    if (user) navigate(user.role === "admin" ? "/admin" : "/account");
  }, [user, navigate]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setMsg(""); setBusy(true);
    try {
      const u = mode === "login"
        ? await login(form.email, form.password)
        : await register(form.name, form.email, form.password);
      navigate(u.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      setMsg(errMsg(err));
      setBusy(false);
    }
  };

  return (
    <PageShell kicker="Your account" title={mode === "login" ? "Welcome back." : "Join the ritual."}
      sub={mode === "login" ? "Sign in to pick up where you left off." : "Create an account to track orders and save your cart."}>
      <div className="wrap" style={{ paddingBottom: 60 }}>
        <div className="auth-card fade-up">
          <div className="auth-tabs">
            <button className={mode === "login" ? "on" : ""} onClick={() => { setMode("login"); setMsg(""); }} data-testid="auth-tab-login">Sign in</button>
            <button className={mode === "register" ? "on" : ""} onClick={() => { setMode("register"); setMsg(""); }} data-testid="auth-tab-register">Create account</button>
          </div>
          <form onSubmit={submit} data-testid="auth-form">
            {mode === "register" && (
              <label className="field"><span>Name</span>
                <input required value={form.name} onChange={set("name")} placeholder="Your name" data-testid="auth-name-input" /></label>
            )}
            <label className="field"><span>Email</span>
              <input required type="email" autoComplete="email" value={form.email} onChange={set("email")} placeholder="name@email.com" data-testid="auth-email-input" /></label>
            <label className="field"><span>Password</span>
              <input required type="password" minLength={6} autoComplete={mode === "login" ? "current-password" : "new-password"}
                value={form.password} onChange={set("password")} placeholder="••••••••" data-testid="auth-password-input" /></label>
            <p className={"form-msg" + (msg ? " err" : "")} role="status" aria-live="polite" data-testid="auth-msg">{msg}</p>
            <button className="kbtn wide" type="submit" disabled={busy} data-testid="auth-submit-btn">
              {busy ? "One moment\u2026" : mode === "login" ? "Sign in" : "Create account"}
            </button>
          </form>
          <div className="auth-or">or</div>
          <button className="kbtn ghost wide" onClick={googleLogin} data-testid="auth-google-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="#EA4335" d="M12 5.04c1.62 0 3.06.56 4.2 1.64l3.12-3.12C17.46 1.8 14.96.75 12 .75 7.42.75 3.48 3.38 1.56 7.22l3.66 2.84C6.12 7.14 8.82 5.04 12 5.04z" />
              <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58l3.68 2.85c2.15-1.99 3.74-4.93 3.74-8.67z" />
              <path fill="#FBBC05" d="M5.22 14.27a7.06 7.06 0 0 1 0-4.21L1.56 7.22a11.28 11.28 0 0 0 0 10.12l3.66-3.07z" />
              <path fill="#34A853" d="M12 23.25c3 0 5.52-.99 7.36-2.69l-3.68-2.85c-1.02.69-2.34 1.1-3.68 1.1-3.18 0-5.88-2.1-6.78-5.02l-3.66 3.07c1.92 3.84 5.86 6.39 10.44 6.39z" />
            </svg>
            Continue with Google
          </button>
        </div>
      </div>
    </PageShell>
  );
}
